import { motion } from "framer-motion";

export default function PageLoader() {
  return (
    <motion.div
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-forest"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      data-testid="page-loader"
    >
      <motion.img
        src="/images/logo.png"
        alt="Nishmayy Global"
        className="w-40 select-none md:w-52"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      />
      <motion.p
        className="mt-6 text-xs uppercase tracking-[0.4em] text-gold"
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.6 }}
      >
        Nishmayy Global
      </motion.p>
      <motion.div
        className="mt-6 h-px bg-gold"
        initial={{ width: 0 }}
        animate={{ width: 120 }}
        transition={{ delay: 0.6, duration: 0.9, ease: "easeOut" }}
      />
    </motion.div>
  );
}
